import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { UserType } from "../../../utils/enum";
import EditWorkExperienceModal from "../components/EditWorkExperienceModal";

const WorkExperience = ({ category, vendor, services, authRole, hasUpdateAccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <BaseCard className="pt-4 pb-6 xl:px-16 px-5  rounded-lg !mb-[0px] h-full" elevation={1}>
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="text-dark">Work Experience</h6>
        {authRole === UserType?.CLIENT && hasUpdateAccess && (
          <i
            className="fa-light fa-pencil text-gray-900 ml-3 cursor-pointer"
            onClick={() => setIsModalOpen(true)}
          ></i>
        )}
      </div>
      <div>
        <div className="pt-2 px-3 rounded-md flex flex-col sm:flex-row  mb-2.5 border-b pb-5">
          <p className="font-normal sm:min-w-40">Technology Stacks:</p>

          <div className="flex flex-wrap gap-2 min-w-0">
            {category?.category && (
              <p className="font-light bg-[#F6F6F6] rounded-sm  px-3 py-[1px]  break-words">
                {category?.category}
              </p>
            )}
          </div>
        </div>

        <div className="pt-2 px-3 rounded-md flex flex-col sm:flex-row  mb-2.5  border-b pb-5">
          <p className="font-normal sm:min-w-40">Category:</p>

          <div className="flex flex-wrap gap-2 min-w-0">
            {category?.vendor?.name && (
              <p className="font-light bg-[#F6F6F6] rounded-sm  px-3 py-[1px]  break-words">
                {category?.vendor?.name}
              </p>
            )}
          </div>
        </div>

        <div className="pt-2 px-3 rounded-md flex flex-col sm:flex-row  mb-2.5">
          <p className="font-normal sm:min-w-40">Skills:</p>

          <div className="flex flex-wrap gap-2 min-w-0">
            {category?.vendor?.services?.map((service, index) => (
              <p
                className="font-light bg-[#F6F6F6] rounded-sm  px-3 py-[1px]  break-words"
                key={index}
              >
                {service?.subCategory}
              </p>
            ))}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <EditWorkExperienceModal
          open={isModalOpen}
          close={() => setIsModalOpen(false)}
          workExperienceData={{
            ...category,
          }}
        />
      )}
    </BaseCard>
  );
};

export default WorkExperience;
